import React from "react";

export default function RestaurantContractText({ text, label = "Texto completo del contrato" }) {
  return <div className="restaurant-contract__text" tabIndex={0} role="region" aria-label={label}>
    {String(text || "").split(/\r?\n/).map((line, index) => <div key={index}>{line || <br />}</div>)}
  </div>;
}
